import l10n from '../../../../lang/locallang';

export class SortingActivityClass {

    run() {
        const containers = document.querySelectorAll('.editor-sorting-activity');
        if (!containers) {
            return false;
        }
        for (let container of containers) {
            this.dragAndDrop(container);
        }
        this.dragAndDrop();
        this.resetQuestionnaire();
    }

    /**
     * Counter with correct/wrong answers
     * @param correct
     * @param wrong
     * */
    counterAnswers(correct = 0, wrong = 0, reset = false, container) {
        const { correctStatus, wrongStatus } = l10n.customCourse;
        let element = container.querySelector('.sorting-activity-result-text');
        let correct_count = 0;
        let wrong_count = 0;
        if (element.querySelector('span:nth-child(1) b')) {
            correct_count = parseInt(element.querySelector('span:nth-child(1) b').innerText);
        }
        if (element.querySelector('span:nth-child(2) b')) {
            wrong_count = parseInt(element.querySelector('span:nth-child(2) b').innerText);
        }
        if (reset) {
            element.innerHTML = `<span>${correctStatus}: <b>0</b></span> <span>${wrongStatus}: <b>0</b></span>`;
        } else {
            if (correct === 1) {
                correct_count = correct_count + 1;
            }
            if (wrong === 1) {
                wrong_count = wrong_count + 1;
            }
            element.innerHTML = `<span>${correctStatus}: <b>${correct_count}</b></span> <span>${wrongStatus}: <b>${wrong_count}</b></span>`;
        }
    }

    /**
     * Processing on drag and drop cards to areas with answers
     * */
    dragAndDrop() {
        let container = null;
        let state = false;
        let activeElementToMove = null;
        let prevX = 0;
        let prevY = 0;

        const handleMouseDown = (e) => {
            container = e.target.closest('.editor-section');
            const sortingActivityItem = e.target.closest('.sorting-activity-item');
            if (sortingActivityItem) {
                state = true;
                activeElementToMove = sortingActivityItem;
                prevX = e.pageX;
                prevY = e.pageY;
            }
        };

        const handleMouseMove = (e) => {
            if(!container) {
                return false;
            }
            if (state) {
                let deltaX = e.pageX - prevX;
                let deltaY = e.pageY - prevY;
                let panelTop = activeElementToMove.offsetTop + deltaY;
                let panelLeft = activeElementToMove.offsetLeft + deltaX;
                activeElementToMove.classList.add('sorting-activity-item--dragging');
                activeElementToMove.style.transition = 'none';
                activeElementToMove.style.top = `${panelTop}px`;
                activeElementToMove.style.left = `${panelLeft}px`;
                prevX = e.pageX;
                prevY = e.pageY;

                //detect collision with sections
                const areas = container.querySelectorAll('.sorting-activity-area');
                for (const area of areas) {
                    const areaRect = area.getBoundingClientRect();
                    const panelRect = activeElementToMove.getBoundingClientRect();
                    if (panelRect.top < areaRect.bottom &&
                        panelRect.bottom > areaRect.top &&
                        panelRect.right > areaRect.left &&
                        panelRect.left < areaRect.right) {
                        area.classList.add('sorting-activity-area--active');
                    } else {
                        area.classList.remove('sorting-activity-area--active');
                    }
                }
            }
        };

        const handleMouseUp = (e) => {
            if(!container) {
                return false;
            }
            state = false;
            let is_correct = false;
            let is_wrong = false;
            let sortingActivityItem = activeElementToMove;
            if (sortingActivityItem) {
                if (container.querySelector('.sorting-activity-area--active')) {
                    let area = container.querySelector('.sorting-activity-area--active');
                    area.classList.remove('sorting-activity-area--active');
                    let rightAnswer = sortingActivityItem.dataset.category;
                    let currentCard = area.dataset.id;
                    if (rightAnswer === currentCard) {
                        is_correct = this.correctAnswer(area, sortingActivityItem);
                    } else {
                        is_wrong = this.wrongAnswer(area, sortingActivityItem);
                    }
                }
                if (!is_correct && !is_wrong) {
                    setTimeout(() => {
                        let panel = sortingActivityItem;
                        panel.style.transition = 'all 0.4s ease';
                        panel.style.top = `0px`;
                        panel.style.left = `0px`;
                        sortingActivityItem.classList.remove('sorting-activity-item--dragging');
                    }, 50);
                }
            }
        };

        document.addEventListener('mousedown', handleMouseDown);
        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
    }

    /**
     * If answer was correct, move card to right area and change counter with right answers
     * @param area
     * @param current
     * */
    correctAnswer(area, current) {
        let areaPosition = area.getBoundingClientRect();
        current.classList.add('__correct-answer');
        current.style.transition = 'all 0.4s ease';
        current.style.top = `${Math.floor(area.offsetTop - (areaPosition.height / 2) + 20)}px`;
        current.style.left = `${Math.floor(area.offsetLeft - current.closest('.sorting-activity-stack').offsetLeft)}px`;

        setTimeout(e => {
            current.classList.add('__correct-answer-process');
            area.classList.add('overflow-hidden');
        }, 300);

        setTimeout(e => {
            area.appendChild(current);
            current.style.top = `auto`;
            current.style.left = `auto`;
        }, 500);

        setTimeout(e => {
            current.classList.add('__correct-answer-done');
        }, 1000);
        this.counterAnswers(1, 0, false, current.closest('.editor-section'));
        return true;
    }

    /**
     * If answer was wrong, move card to stack with cards and change counter with wrong answers
     * @param current
     * */
    wrongAnswer(area, current) {
        current.classList.add('__wrong');
        let areaPosition = area.getBoundingClientRect();
        current.style.transition = 'all 0.4s ease';
        console.log(area.offsetTop, areaPosition.height)
        // positioning current element in center of area element
        current.style.top = `${Math.floor(area.offsetTop - (areaPosition.height / 2) + 20)}px`;
        current.style.left = `${Math.floor(area.offsetLeft - current.closest('.sorting-activity-stack').offsetLeft)}px`;

        setTimeout(e => {
            current.classList.add('__wrong-notification');
        }, 200);

        // back to stack
        setTimeout(() => {
            let panel = current;
            panel.style.transition = 'all 0.4s ease';
            panel.style.top = `0px`;
            panel.style.left = `0px`;
            if (current.classList.contains('sorting-activity-item--dragging')) {
                current.classList.remove('sorting-activity-item--dragging');
            }
            if (current.classList.contains('__wrong')) {
                current.classList.remove('__wrong');
            }
            if (current.classList.contains('__wrong-notification')) {
                current.classList.remove('__wrong-notification');
            }
        }, 1000);

        this.counterAnswers(0, 1, false, current.closest('.editor-section'));
        return true;
    }

    resetQuestionnaire() {
        window.addEventListener('click', e => {
            const button = e.target.closest('.sorting-activity-reset-btn');
            if (button) {
                e.preventDefault();
                const container = button.closest('.editor-sorting-activity');
                const cards = container.querySelectorAll('.sorting-activity-item.__correct-answer-done');
                const cardsStack = container.querySelector('.sorting-activity-stack');
                if (!cards) {
                    return false;
                }
                for (let card of cards) {
                    card.classList.remove('__correct-answer');
                    card.classList.remove('__correct-answer-process');
                    card.classList.remove('__correct-answer-done');
                    card.classList.remove('__wrong');
                    card.classList.remove('sorting-activity-item--dragging');
                    cardsStack.appendChild(card);
                }
                this.counterAnswers(0, 0, true, container);
                container.querySelector('.sorting-activity-result-text').innerHTML = '';
            }
        });
    }
}
